// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClsInboundDocument {
    'documentID'?: string;
    'documentName'?: string;
    'documentCategory'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClsInboundDocument>> = [
        {
            "name":     "documentID",
            "baseName": "documentID",
            "type":     "string"
        },
        {
            "name":     "documentName",
            "baseName": "documentName",
            "type":     "string"
        },
        {
            "name":     "documentCategory",
            "baseName": "documentCategory",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ClsInboundDocument.attributeTypeMap;
    }
}
